/**
 * 配置项：
 * isShowMD5          必填    int     是否显示md5 1：显示 0：不显示
 * isLightOrShade     必填    int     生成明水印或暗水印 1：明水印 2：暗水印
 * isOnlyPushData	  必填    int     是否仅做敏感数据推送 1：是 0：否
 * waterMarkContent	  非必填	string	水印内容 限制40个字符 默认值 官方客服：4000-598-598 唯一公众号："易鑫车主服务"
 * width	          非必填	int	    图片宽度 默认值300
 * height	          非必填	int	    图片高度 默认值300
 * color	          非必填	string	字体颜色字符串 无默认值 例:#ff0000 仅供眀水印使用
 * degree	          非必填	Double	水印文字旋转角度 默认值 -30d 仅供眀水印使用
 * alpha	          非必填	float	水印不透明度 0f-1.0f 默认值0.3f 仅供眀水印使用
 * fontSize	          非必填	int	    水印文字大小 默认值24 仅供眀水印使用
 * platformCode       必填    string  所属平台 由内容管理平台提供
 * sensitiveDataMap   必填    Map     用于存放本次操作涉及到的用户信息及隐私信息，具体内容和字段根据系统实际情况存放
 *  @param message	    非必填	String	各系统根据实际情况按需存放任意敏感数据，内容可为查询所有参数
 *  @param ip	        必填	String	Ip地址 (公网ip)
 *  @param time	        必填	Date	调用时间
 *  @param domain	    必填    String	系统名称。可自定义中文名称，或直接填写项目域名，仅用于标识不同系统。
 *  @param department	必填	String	系统所属部门
 *  @param userId	    必填	String	域账号为必填项
 *  @param userName	    必填	String	用户名为必填项
 *  @param phone	    非必填	String	联系电话
 *  @param email	    非必填	String	邮件
 */

import Vue from "vue";


import {creatWatermarkReq} from '@/api/commonApi'



export function creatWatermark (URL, MEMOOBJ, PARAMS, CONFIG) {
  let watermark_base64 = null;
  let DEFAULT_PARAMS = {
    isShowMD5: 1,
    isLightOrShade: 1,
    width: 200,
    height: 200,
    color: "#bfbfbf",
    alpha: 0.25,
    degree: -60,
    fontSize: 13,
    platformCode: "xde",
    sensitiveDataMap: {
      "memo": MEMOOBJ || "无"
    }
  };
  CONFIG = CONFIG || {};
  CONFIG.gradient = 40;
  // replace default settings
  if (PARAMS && Object.keys(PARAMS).length > 0) {
    for (let key in PARAMS) {
      DEFAULT_PARAMS[key] = PARAMS[key];
    }
  }
  let clientWidth = document.body.clientWidth || document.documentElement.clientWidth;
  let clientHeight = document.body.clientHeight || document.documentElement.clientHeight;
  let extraWidth = 0;
  if (clientWidth >= clientHeight) {
    extraWidth = -0.5 * clientWidth;
  } else {
    extraWidth = -0.5 * clientHeight;
  }

 

  creatWatermarkReq(DEFAULT_PARAMS).then(res => {
   if (res.code == 0) {
      watermark_base64 = "data:image/png;base64," + res.data.info;
      // setting images in document
      let oDiv = document.getElementById("watermark_jrkjb");
      if (oDiv) { oDiv.parentNode.removeChild(oDiv); }
      let oTemp = document.createDocumentFragment();
      let wrap_div = document.createElement("div");
      wrap_div.setAttribute("id", "watermark_jrkjb");
      wrap_div.style.top = extraWidth + "px";
      wrap_div.style.bottom = extraWidth + "px";
      wrap_div.style.left = extraWidth + "px";
      wrap_div.style.right = extraWidth + "px";
      wrap_div.style.zIndex = 10000;
      wrap_div.style.backgroundImage = `url(${watermark_base64})`;
      wrap_div.style.position = "fixed";
      wrap_div.style.pointerEvents = "none";
      wrap_div.style.transform = "rotate(" + CONFIG.gradient + "deg)";
      wrap_div.style.webkitTransform = "rotate(" + CONFIG.gradient + "deg)"; /* Safari 和 Chrome */
      wrap_div.style.MozTransform = "rotate(" + CONFIG.gradient + "deg)"; /* Firefox */
      wrap_div.style.msTransform = "rotate(" + CONFIG.gradient + "deg)"; /* IE 9 */
      wrap_div.style.OTransform = "rotate(" + CONFIG.gradient + "deg)"; /* Opera */
      oTemp.appendChild(wrap_div);
      document.body.appendChild(oTemp);
    } else {
      Vue.prototype.$Message.warning({
        content: "获取水印" + res.msg,
        duration: 5
      });
    }
  }).catch((error) => {
    Vue.prototype.$Message.error({
      content: "请求出现异常" + error,
      duration: 5
    });
  });
}
